export default __webpack_public_path__ + "static/media/new_login_image.736f3194.png";